module.exports = __webpack_public_path__ + "static/img/1_0006.b8c5914.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0006.jpg
// module id = LQ5J
// module chunks = 0